<div
  class="games-container container-fluid"
  style="min-height: 500px"
  [attr.data-panels-ready]="panelsReady"
>
  <app-game-navigation [game]="game" [leagueName]="selectedLeague?.shortName">
    <app-game-action-menu
      #actionMenu
      [game]="game"
      (statusUpdated)="onStatusUpdated($event)"
    ></app-game-action-menu>
  </app-game-navigation>

  <div class="card">
    <h5 class="card-header mt-0" (click)="showEssential = !showEssential">
      Essentials
    </h5>
    <div class="card-body" [style.display]="showEssential ? 'block' : 'none'">
      <app-game-details-card-essentials
        [game]="game"
        [gameUnmodified]="gameUnmodified"
        [seasons]="seasons"
        [leagues]="leagues"
        [teams]="teams"
        (seasonChange)="onSeasonChange($event)"
        (idTypeChange)="onIdTypeChange($event)"
        (leagueChange)="onLeagueChange($event)"
        (homeTeamChange)="onHomeTeamChange($event)"
        (awayTeamChange)="onAwayTeamChange($event)"
      ></app-game-details-card-essentials>
    </div>
  </div>

  <div class="card mt-3">
    <h5 class="card-header mt-0" (click)="showCollection = !showCollection"
      >Collection
    </h5>
    <div class="card-body" [style.display]="showCollection ? 'block' : 'none'">
      <div class="row mt-3">
        <div class="col-2">
          <label>Data Set</label>
          <select
            [(ngModel)]="game.dataSet"
            (ngModelChange)="onDataSetChange($event)"
            name="dataSet"
            class="form-control"
          >
            <option></option>
            <option *ngFor="let dataSet of dataSets" [value]="dataSet">{{
              dataSet
            }}</option>
          </select>
        </div>
        <div class="col-2">
          <label>Officiating Data Set</label>
          <select
            [(ngModel)]="game.officiatingDataSet"
            name="officiatingDataSet"
            class="form-control"
          >
            <option></option>
            <option
              *ngFor="let dataSet of officiatingDataSets"
              [value]="dataSet"
              >{{ dataSet }}</option
            >
          </select>
        </div>
        <div class="col-3">
          <label>Collector</label>
          <input
            name="event_collector_name"
            class="form-control"
            [(ngModel)]="game.eventCollectorName"
          />
        </div>
        <div class="col-3">
          <label>Tags</label>
          <div class="tags">
            <app-tag-form-field
              class="game-details"
              [tags]="game.tags"
              (tagChange)="tagsChange($event)"
            ></app-tag-form-field>
          </div>
        </div>
      </div>
      <span *ngFor="let groupKey of Object.keys(getVisibleCollectionGroups())">
        <h3>{{ groupKey | titlecase }}</h3>
        <div class="row">
          <div *ngFor="let option of collectionOptions(groupKey)" class="col-2">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                [id]="option.id"
                [name]="option.id"
                [(ngModel)]="game[option.fieldName]"
                (ngModelChange)="collectionOptionChanged(option, $event)"
              />
              <label
                class="form-check-label"
                [for]="option.id"
                [matTooltip]="collectionOptionTooltip(option)"
                matTooltipShowDelay="500"
                >{{ option.label }}
              </label>
            </div>
          </div>
        </div>
      </span>
    </div>
  </div>

  <div class="card mt-3">
    <h5 class="card-header mt-0" (click)="showVideos = !showVideos"
      >Videos ({{ game.videos?.length }})</h5
    >
    <div class="card-body" [style.display]="showVideos ? 'block' : 'none'">
      <app-game-details-videos-card
        [game]="game"
        [isSyncingLiveStreams]="isSyncingLiveStreams"
        (addVideo)="addVideo($event)"
        (removeVideo)="removeVideo($event)"
        (downloadVideo)="downloadVideo($event)"
        (videoUrlChange)="videoUrlChanged($event)"
        (uploadVideo)="uploadVideo($event)"
        (liveStreamAdded)="liveStreamAdded($event)"
        (syncLiveStreams)="syncLiveStreams()"
      ></app-game-details-videos-card>
    </div>
  </div>

  <div class="card mt-3">
    <h5 class="card-header mt-0" (click)="showOfficials = !showOfficials"
      >Officials</h5
    >
    <div class="card-body" [style.display]="showOfficials ? 'block' : 'none'">
      <div class="row">
        <app-official-input
          *ngFor="let gameOfficialField of gameOfficialFields"
          class="col-12 col-lg-3"
          [officialLabel]="gameOfficialField.label"
          [official]="
            findOfficial(
              gameOfficialField.role,
              gameOfficialField.sequenceNumber
            )
          "
          [unknownOfficialInfo]="
            findGameOfficial(
              gameOfficialField.role,
              gameOfficialField.sequenceNumber
            )?.unknownOfficialInfo
          "
          [disabled]="isOfficialEditDisabled"
          [disabledTooltip]="'Officials cannot be changed'"
          (officialChange)="
            updateGameOfficial(
              $event?.officialId,
              $event?.jerseyNumber,
              gameOfficialField.role,
              gameOfficialField.sequenceNumber
            )
          "
        ></app-official-input>
      </div>
    </div>
  </div>

  <div class="card mt-3">
    <h5 class="card-header mt-0" (click)="showLineup = !showLineup">Lineup</h5>
    <div class="card-body" [style.display]="showLineup ? 'block' : 'none'">
      <div class="form-check">
        <mat-slide-toggle [(ngModel)]="customLineup"
          >Custom Lineup</mat-slide-toggle
        >
      </div>

      <mat-tab-group mat-stretch-tabs>
        <mat-tab
          [label]="game?.homeTeam ? 'Lineup ' + game.homeTeam : 'Home Lineup'"
        >
          <div class="customer-lineup-actions">
            <button
              mat-raised-button
              color="primary"
              *ngIf="hasCustomerLineup('home') && !homeCustomerLineupApplied"
              (click)="applyCustomerLineup('home')"
            >
              Apply Customer Lineup
            </button>
            <button
              mat-raised-button
              color="warn"
              *ngIf="homeCustomerLineupApplied"
              (click)="revertLineup('home')"
            >
              Revert Customer Lineup
            </button>
            <span
              *ngIf="
                !hasCustomerLineup('home') && !game?.customerLineupUnavailable
              "
              class="no-lineup-message"
            >
              No customer lineup available
            </span>
            <span
              *ngIf="
                !hasCustomerLineup('home') && game?.customerLineupUnavailable
              "
              class="lineup-load-warning"
            >
              Couldn't load the customer lineup — refresh to try again
            </span>
          </div>
          <ng-container
            *ngIf="
              customLineup;
              then unknownHomeTeamPlayers;
              else knownHomeTeamPlayers
            "
            >here is ignored</ng-container
          >
        </mat-tab>
        <mat-tab
          [label]="game?.homeTeam ? 'Lineup ' + game.awayTeam : 'Away Lineup'"
        >
          <div class="customer-lineup-actions">
            <button
              mat-raised-button
              color="primary"
              *ngIf="hasCustomerLineup('away') && !awayCustomerLineupApplied"
              (click)="applyCustomerLineup('away')"
            >
              Apply Customer Lineup
            </button>
            <button
              mat-raised-button
              color="warn"
              *ngIf="awayCustomerLineupApplied"
              (click)="revertLineup('away')"
            >
              Revert Customer Lineup
            </button>
            <span
              *ngIf="
                !hasCustomerLineup('away') && !game?.customerLineupUnavailable
              "
              class="no-lineup-message"
            >
              No customer lineup available
            </span>
            <span
              *ngIf="
                !hasCustomerLineup('away') && game?.customerLineupUnavailable
              "
              class="lineup-load-warning"
            >
              Couldn't load the customer lineup — refresh to try again
            </span>
          </div>
          <ng-container
            *ngIf="
              customLineup;
              then unknownAwayTeamPlayers;
              else knownAwayTeamPlayers
            "
            >here is ignored</ng-container
          >
        </mat-tab>
      </mat-tab-group>

      <ng-template #knownHomeTeamPlayers>
        <div class="row">
          <h5 class="col-sm-12 col-lg-1">GK</h5>

          <app-all-players-input
            class="col-12 col-lg-3"
            position="goalkeeper"
            positionName="Goalkeeper"
            positionKey="homeGoalkeeper"
            [idType]="game.idType"
            [player]="game.homeGoalkeeper"
            [playerId]="game.homeGoalkeeperID"
            [players]="homeTeamPlayers"
            [teamName]="game.homeTeam"
            (playerChange)="
              handlePlayerSelect($event.player, $event.positionKey)
            "
          ></app-all-players-input>

          <app-all-players-input
            class="col-sm-12 col-lg-3"
            position="goalkeeper"
            positionName="Backup Goalkeeper"
            positionKey="homeBackupGoalkeeper"
            [idType]="game.idType"
            [player]="game.homeBackupGoalkeeper"
            [playerId]="game.homeBackupGoalkeeperID"
            [players]="homeTeamPlayers"
            [teamName]="game.homeTeam"
            (playerChange)="
              handlePlayerSelect($event.player, $event.positionKey)
            "
          ></app-all-players-input>
        </div>

        <ng-container *ngFor="let line of visibleLines; let i = index">
          <div class="row">
            <h5 class="col-sm-12 col-lg-1">{{ i + 1 }}</h5>
            <app-all-players-input
              class="col-sm-12 col-lg"
              position="defender"
              positionName="Left Defender"
              positionKey="{{ 'home' + line + 'LeftDefence' }}"
              [idType]="game.idType"
              [players]="homeTeamPlayers"
              [teamName]="game.homeTeam"
              [player]="game['home' + line + 'LeftDefence']"
              [playerId]="game['home' + line + 'LeftDefenceID']"
              (playerChange)="
                handlePlayerSelect($event.player, $event.positionKey)
              "
            ></app-all-players-input>
            <app-all-players-input
              class="col-sm-12 col-lg"
              position="defender"
              positionName="Right Defender"
              positionKey="{{ 'home' + line + 'RightDefence' }}"
              [idType]="game.idType"
              [player]="game['home' + line + 'RightDefence']"
              [playerId]="game['home' + line + 'RightDefenceID']"
              [players]="homeTeamPlayers"
              [teamName]="game.homeTeam"
              (playerChange)="
                handlePlayerSelect($event.player, $event.positionKey)
              "
            ></app-all-players-input>

            <app-all-players-input
              class="col-sm-12 col-lg"
              position="forward"
              positionName="Left Forward"
              positionKey="{{ 'home' + line + 'LeftForward' }}"
              [idType]="game.idType"
              [player]="game['home' + line + 'LeftForward']"
              [playerId]="game['home' + line + 'LeftForwardID']"
              [players]="homeTeamPlayers"
              [teamName]="game.homeTeam"
              (playerChange)="
                handlePlayerSelect($event.player, $event.positionKey)
              "
            ></app-all-players-input>

            <app-all-players-input
              class="col-sm-12 col-lg"
              position="forward"
              positionName="Center"
              positionKey="{{ 'home' + line + 'Center' }}"
              [idType]="game.idType"
              [player]="game['home' + line + 'Center']"
              [playerId]="game['home' + line + 'CenterID']"
              [players]="homeTeamPlayers"
              [teamName]="game.homeTeam"
              (playerChange)="
                handlePlayerSelect($event.player, $event.positionKey)
              "
            ></app-all-players-input>

            <app-all-players-input
              class="col-sm-12 col-lg"
              position="forward"
              positionName="Right Forward"
              positionKey="{{ 'home' + line + 'RightForward' }}"
              [idType]="game.idType"
              [player]="game['home' + line + 'RightForward']"
              [playerId]="game['home' + line + 'RightForwardID']"
              [players]="homeTeamPlayers"
              [teamName]="game.homeTeam"
              (playerChange)="
                handlePlayerSelect($event.player, $event.positionKey)
              "
            ></app-all-players-input>
          </div>
        </ng-container>
      </ng-template>

      <ng-template #unknownHomeTeamPlayers>
        <h5>Goalkeepers</h5>
        <app-custom-player-input
          [game]="game"
          positionKey="homeGoalkeeper"
          positionName="Goalkeeper"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="homeBackupGoalkeeper"
          positionName="Backup Goalkeeper"
        ></app-custom-player-input>

        <h5>First line</h5>
        <app-custom-player-input
          [game]="game"
          positionKey="homeFirstLineLeftDefence"
          positionName="Left Defence"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="homeFirstLineRightDefence"
          positionName="Right Defence"
        ></app-custom-player-input>
        <br />
        <app-custom-player-input
          [game]="game"
          positionKey="homeFirstLineLeftForward"
          positionName="Left Forward"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="homeFirstLineCenter"
          positionName="Center"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="homeFirstLineRightForward"
          positionName="Right Forward"
        ></app-custom-player-input>

        <h5>Second line</h5>
        <app-custom-player-input
          [game]="game"
          positionKey="homeSecondLineLeftDefence"
          positionName="Left Defence"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="homeSecondLineRightDefence"
          positionName="Right Defence"
        ></app-custom-player-input>
        <br />
        <app-custom-player-input
          [game]="game"
          positionKey="homeSecondLineLeftForward"
          positionName="Left Forward"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="homeSecondLineCenter"
          positionName="Center"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="homeSecondLineRightForward"
          positionName="Right Forward"
        ></app-custom-player-input>

        <h5>Third line</h5>
        <app-custom-player-input
          [game]="game"
          positionKey="homeThirdLineLeftDefence"
          positionName="Left Defence"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="homeThirdLineRightDefence"
          positionName="Right Defence"
        ></app-custom-player-input>
        <br />
        <app-custom-player-input
          [game]="game"
          positionKey="homeThirdLineLeftForward"
          positionName="Left Forward"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="homeThirdLineCenter"
          positionName="Center"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="homeThirdLineRightForward"
          positionName="Right Forward"
        ></app-custom-player-input>

        <h5>Fourth line</h5>
        <app-custom-player-input
          [game]="game"
          positionKey="homeFourthLineLeftDefence"
          positionName="Left Defence"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="homeFourthLineRightDefence"
          positionName="Right Defence"
        ></app-custom-player-input>
        <br />
        <app-custom-player-input
          [game]="game"
          positionKey="homeFourthLineLeftForward"
          positionName="Left Forward"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="homeFourthLineCenter"
          positionName="Center"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="homeFourthLineRightForward"
          positionName="Right Forward"
        ></app-custom-player-input>

        <h5>Fifth/Extra line</h5>
        <app-custom-player-input
          [game]="game"
          positionKey="homeFifthLineLeftDefence"
          positionName="Left Defence"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="homeFifthLineRightDefence"
          positionName="Right Defence"
        ></app-custom-player-input>
        <br />
        <app-custom-player-input
          [game]="game"
          positionKey="homeFifthLineLeftForward"
          positionName="Left Forward"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="homeFifthLineCenter"
          positionName="Center"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="homeFifthLineRightForward"
          positionName="Right Forward"
        ></app-custom-player-input>

        <ng-container *ngIf="game.enableExtraLines">
        <h5>Sixth line</h5>
        <app-custom-player-input
          [game]="game"
          positionKey="homeSixthLineLeftDefence"
          positionName="Left Defence"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="homeSixthLineRightDefence"
          positionName="Right Defence"
        ></app-custom-player-input>
        <br />
        <app-custom-player-input
          [game]="game"
          positionKey="homeSixthLineLeftForward"
          positionName="Left Forward"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="homeSixthLineCenter"
          positionName="Center"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="homeSixthLineRightForward"
          positionName="Right Forward"
        ></app-custom-player-input>

        <h5>Seventh line</h5>
        <app-custom-player-input
          [game]="game"
          positionKey="homeSeventhLineLeftDefence"
          positionName="Left Defence"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="homeSeventhLineRightDefence"
          positionName="Right Defence"
        ></app-custom-player-input>
        <br />
        <app-custom-player-input
          [game]="game"
          positionKey="homeSeventhLineLeftForward"
          positionName="Left Forward"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="homeSeventhLineCenter"
          positionName="Center"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="homeSeventhLineRightForward"
          positionName="Right Forward"
        ></app-custom-player-input>

        <h5>Eighth line</h5>
        <app-custom-player-input
          [game]="game"
          positionKey="homeEighthLineLeftDefence"
          positionName="Left Defence"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="homeEighthLineRightDefence"
          positionName="Right Defence"
        ></app-custom-player-input>
        <br />
        <app-custom-player-input
          [game]="game"
          positionKey="homeEighthLineLeftForward"
          positionName="Left Forward"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="homeEighthLineCenter"
          positionName="Center"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="homeEighthLineRightForward"
          positionName="Right Forward"
        ></app-custom-player-input>
        </ng-container>
      </ng-template>

      <ng-template #knownAwayTeamPlayers>
        <div class="row">
          <h5 class="col-sm-12 col-lg-1">Goalkeepers</h5>

          <app-all-players-input
            class="col-12 col-lg-3"
            position="goalkeeper"
            positionName="Goalkeeper"
            positionKey="awayGoalkeeper"
            [idType]="game.idType"
            [player]="game.awayGoalkeeper"
            [playerId]="game.awayGoalkeeperID"
            [players]="awayTeamPlayers"
            [teamName]="game.awayTeam"
            (playerChange)="
              handlePlayerSelect($event.player, $event.positionKey)
            "
          ></app-all-players-input>

          <app-all-players-input
            class="col-sm-12 col-lg-3"
            position="goalkeeper"
            positionName="Backup Goalkeeper"
            positionKey="awayBackupGoalkeeper"
            [idType]="game.idType"
            [player]="game.awayBackupGoalkeeper"
            [playerId]="game.awayBackupGoalkeeperID"
            [players]="awayTeamPlayers"
            [teamName]="game.awayTeam"
            (playerChange)="
              handlePlayerSelect($event.player, $event.positionKey)
            "
          ></app-all-players-input>
        </div>

        <ng-container *ngFor="let line of visibleLines">
          <div class="row">
            <h5 class="col-sm-12 col-lg-1">{{ line }}</h5>
            <app-all-players-input
              class="col-sm-12 col-lg"
              position="defender"
              positionName="Left Defender"
              positionKey="{{ 'away' + line + 'LeftDefence' }}"
              [idType]="game.idType"
              [player]="game['away' + line + 'LeftDefence']"
              [playerId]="game['away' + line + 'LeftDefenceID']"
              [players]="awayTeamPlayers"
              [teamName]="game.awayTeam"
              (playerChange)="
                handlePlayerSelect($event.player, $event.positionKey)
              "
            ></app-all-players-input>
            <app-all-players-input
              class="col-sm-12 col-lg"
              position="defender"
              positionName="Right Defender"
              positionKey="{{ 'away' + line + 'RightDefence' }}"
              [idType]="game.idType"
              [player]="game['away' + line + 'RightDefence']"
              [playerId]="game['away' + line + 'RightDefenceID']"
              [players]="awayTeamPlayers"
              [teamName]="game.awayTeam"
              (playerChange)="
                handlePlayerSelect($event.player, $event.positionKey)
              "
            ></app-all-players-input>

            <app-all-players-input
              class="col-sm-12 col-lg"
              position="forward"
              positionName="Left Forward"
              positionKey="{{ 'away' + line + 'LeftForward' }}"
              [idType]="game.idType"
              [player]="game['away' + line + 'LeftForward']"
              [playerId]="game['away' + line + 'LeftForwardID']"
              [players]="awayTeamPlayers"
              [teamName]="game.awayTeam"
              (playerChange)="
                handlePlayerSelect($event.player, $event.positionKey)
              "
            ></app-all-players-input>

            <app-all-players-input
              class="col-sm-12 col-lg"
              position="forward"
              positionName="Center"
              positionKey="{{ 'away' + line + 'Center' }}"
              [idType]="game.idType"
              [player]="game['away' + line + 'Center']"
              [playerId]="game['away' + line + 'CenterID']"
              [players]="awayTeamPlayers"
              [teamName]="game.awayTeam"
              (playerChange)="
                handlePlayerSelect($event.player, $event.positionKey)
              "
            ></app-all-players-input>

            <app-all-players-input
              class="col-sm-12 col-lg"
              position="forward"
              positionName="Right Forward"
              positionKey="{{ 'away' + line + 'RightForward' }}"
              [idType]="game.idType"
              [player]="game['away' + line + 'RightForward']"
              [playerId]="game['away' + line + 'RightForwardID']"
              [players]="awayTeamPlayers"
              [teamName]="game.awayTeam"
              (playerChange)="
                handlePlayerSelect($event.player, $event.positionKey)
              "
            ></app-all-players-input>
          </div>
        </ng-container>
      </ng-template>

      <ng-template #unknownAwayTeamPlayers>
        <h5>Goalkeepers</h5>
        <app-custom-player-input
          [game]="game"
          positionKey="awayGoalkeeper"
          positionName="Goalkeeper"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="awayBackupGoalkeeper"
          positionName="Backup Goalkeeper"
        ></app-custom-player-input>

        <h5>First line</h5>
        <app-custom-player-input
          [game]="game"
          positionKey="awayFirstLineLeftDefence"
          positionName="Left Defence"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="awayFirstLineRightDefence"
          positionName="Right Defence"
        ></app-custom-player-input>
        <br />
        <app-custom-player-input
          [game]="game"
          positionKey="awayFirstLineLeftForward"
          positionName="Left Forward"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="awayFirstLineCenter"
          positionName="Center"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="awayFirstLineRightForward"
          positionName="Right Forward"
        ></app-custom-player-input>

        <h5>Second line</h5>
        <app-custom-player-input
          [game]="game"
          positionKey="awaySecondLineLeftDefence"
          positionName="Left Defence"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="awaySecondLineRightDefence"
          positionName="Right Defence"
        ></app-custom-player-input>
        <br />
        <app-custom-player-input
          [game]="game"
          positionKey="awaySecondLineLeftForward"
          positionName="Left Forward"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="awaySecondLineCenter"
          positionName="Center"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="awaySecondLineRightForward"
          positionName="Right Forward"
        ></app-custom-player-input>

        <h5>Third line</h5>
        <app-custom-player-input
          [game]="game"
          positionKey="awayThirdLineLeftDefence"
          positionName="Left Defence"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="awayThirdLineRightDefence"
          positionName="Right Defence"
        ></app-custom-player-input>
        <br />
        <app-custom-player-input
          [game]="game"
          positionKey="awayThirdLineLeftForward"
          positionName="Left Forward"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="awayThirdLineCenter"
          positionName="Center"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="awayThirdLineRightForward"
          positionName="Right Forward"
        ></app-custom-player-input>

        <h5>Fourth line</h5>
        <app-custom-player-input
          [game]="game"
          positionKey="awayFourthLineLeftDefence"
          positionName="Left Defence"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="awayFourthLineRightDefence"
          positionName="Right Defence"
        ></app-custom-player-input>
        <br />
        <app-custom-player-input
          [game]="game"
          positionKey="awayFourthLineLeftForward"
          positionName="Left Forward"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="awayFourthLineCenter"
          positionName="Center"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="awayFourthLineRightForward"
          positionName="Right Forward"
        ></app-custom-player-input>

        <h5>Fifth/Extra line</h5>
        <app-custom-player-input
          [game]="game"
          positionKey="awayFifthLineLeftDefence"
          positionName="Left Defence"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="awayFifthLineRightDefence"
          positionName="Right Defence"
        ></app-custom-player-input>
        <br />
        <app-custom-player-input
          [game]="game"
          positionKey="awayFifthLineLeftForward"
          positionName="Left Forward"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="awayFifthLineCenter"
          positionName="Center"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="awayFifthLineRightForward"
          positionName="Right Forward"
        ></app-custom-player-input>

        <ng-container *ngIf="game.enableExtraLines">
        <h5>Sixth line</h5>
        <app-custom-player-input
          [game]="game"
          positionKey="awaySixthLineLeftDefence"
          positionName="Left Defence"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="awaySixthLineRightDefence"
          positionName="Right Defence"
        ></app-custom-player-input>
        <br />
        <app-custom-player-input
          [game]="game"
          positionKey="awaySixthLineLeftForward"
          positionName="Left Forward"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="awaySixthLineCenter"
          positionName="Center"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="awaySixthLineRightForward"
          positionName="Right Forward"
        ></app-custom-player-input>

        <h5>Seventh line</h5>
        <app-custom-player-input
          [game]="game"
          positionKey="awaySeventhLineLeftDefence"
          positionName="Left Defence"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="awaySeventhLineRightDefence"
          positionName="Right Defence"
        ></app-custom-player-input>
        <br />
        <app-custom-player-input
          [game]="game"
          positionKey="awaySeventhLineLeftForward"
          positionName="Left Forward"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="awaySeventhLineCenter"
          positionName="Center"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="awaySeventhLineRightForward"
          positionName="Right Forward"
        ></app-custom-player-input>

        <h5>Eighth line</h5>
        <app-custom-player-input
          [game]="game"
          positionKey="awayEighthLineLeftDefence"
          positionName="Left Defence"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="awayEighthLineRightDefence"
          positionName="Right Defence"
        ></app-custom-player-input>
        <br />
        <app-custom-player-input
          [game]="game"
          positionKey="awayEighthLineLeftForward"
          positionName="Left Forward"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="awayEighthLineCenter"
          positionName="Center"
        ></app-custom-player-input>
        <app-custom-player-input
          [game]="game"
          positionKey="awayEighthLineRightForward"
          positionName="Right Forward"
        ></app-custom-player-input>
        </ng-container>
      </ng-template>
    </div>
  </div>

  <div class="card mt-3">
    <h5 class="card-header mt-0" (click)="showAssistance = !showAssistance"
      >Computer Assistance</h5
    >
    <div class="card-body" [style.display]="showAssistance ? 'block' : 'none'">
      <div
        class="alert alert-info"
        *ngIf="game.isCVCandidate && !game.isCVProcessed"
      >
        <mat-icon style="vertical-align: middle">info</mat-icon>
        {{ game.homeTeam }} is a computer vision collection candidate — this
        game could be collected with CV.
      </div>
      <div class="row" style="height: 48px">
        <div class="col-4">
          <div class="form-check">
            <label class="form-check-label" style="width: 150px"
              >Home Team starts</label
            >
            <label for="left-side">
              <input
                type="radio"
                id="left-side"
                name="left-side"
                [(ngModel)]="game.homeTeamStartPosition"
                value="left"
              />
              <span>Left Side</span>
            </label>
            <label for="right-side" style="margin-left: 16px">
              <input
                type="radio"
                id="right-side"
                name="right-side"
                [(ngModel)]="game.homeTeamStartPosition"
                value="right"
              />
              <span>Right Side</span>
            </label>
          </div>
        </div>
      </div>
      <div class="row" style="height: 48px">
        <div class="col-2">
          <div class="form-check">
            <label
              class="form-check-label"
              for="home_team_color"
              style="width: 100px"
              >Home Color</label
            >
            <input
              type="color"
              class="form-check-input"
              id="home_team_color"
              name="home_team_color"
              style="margin-top: 0"
              [(ngModel)]="game.homeTeamColor"
            />
          </div>
        </div>

        <div class="col-2">
          <div class="form-check">
            <label
              class="form-check-label"
              for="away_team_color"
              style="width: 100px"
              >Away Color</label
            >
            <input
              type="color"
              class="form-check-input"
              id="away_team_color"
              name="away_team_color"
              style="margin-top: 0"
              [(ngModel)]="game.awayTeamColor"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <table style="width: 100%; margin-left: 16px">
            <thead>
              <tr>
                <th>Period</th>
                <th>Phases</th>
                <th>Priority</th>
                <th>Status</th>
                <th></th>
                <th>Created</th>
                <th>Started</th>
                <th>Stopped</th>
                <th>Duration</th>
                <th>Type</th>
                <th>Logs</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let p of game.cvPipeline ?? []"
                [class.cv-error]="isCVError(p)"
              >
                <td>{{ p.period }}</td>
                <td>{{ p.phase }}</td>
                <td>{{ p.priority }}</td>
                <td>
                  <select
                    [(ngModel)]="p.lastStatus"
                    name="result"
                    class="form-control"
                  >
                    <option value=""></option>
                    <option value="SUBMITTED">SUBMITTED</option>
                    <option value="PENDING">PENDING</option>
                    <option value="RUNNABLE">RUNNABLE</option>
                    <option value="STARTING">STARTING</option>
                    <option value="RUNNING">RUNNING</option>
                    <option value="SUCCEEDED">SUCCEEDED</option>
                    <option value="FAILED">FAILED</option>
                  </select>
                </td>
                <td>
                  <mat-icon
                    *ngFor="let warning of getCVWarnings(p)"
                    [matTooltip]="warning.description"
                    style="color: orange"
                    >warning</mat-icon
                  >
                </td>
                <td
                  >{{ p.createdAt | date : 'yyyy-MM-dd HH:mm:ss' }}
                  <mat-icon
                    *ngIf="p.createdBy"
                    [matTooltip]="p.createdBy"
                    style="vertical-align: bottom"
                    >person</mat-icon
                  ></td
                >
                <td
                  >{{ p.startedAt ?? p.start | date : 'yyyy-MM-dd HH:mm:ss' }}
                </td>
                <td
                  >{{ p.stoppedAt ?? p.stop | date : 'yyyy-MM-dd HH:mm:ss' }}
                </td>
                <td>{{
                  duration(p.startedAt ?? p.start, p.stoppedAt ?? p.stop)
                    | hhmmss
                }}</td>
                <td> {{ cvTaskType(p) }} / {{ p.version }} </td>
                <td>
                  <div *ngIf="p.logUrl">
                    <a
                      [href]="domSanitizer.bypassSecurityTrustUrl(p.logUrl)"
                      target="_blank"
                      ><mat-icon style="vertical-align: middle">link </mat-icon>
                    </a>
                  </div>
                  <div *ngIf="!p.logUrl">
                    <mat-icon style="vertical-align: middle"
                      >link_off
                    </mat-icon>
                  </div>
                </td>
                <td>
                  <button mat-icon-button (click)="deleteCVPipelineRecord(p)"
                    ><mat-icon>delete</mat-icon></button
                  >
                </td>
              </tr>
            </tbody>
          </table>

          <div class="form-check" style="margin-top: 16px">
            <input
              type="checkbox"
              class="form-check-input"
              id="isCVProcessed"
              name="isCVProcessed"
              [(ngModel)]="game.isCVProcessed"
            />
            <label class="form-check-label" for="isCVProcessed"
              >CV Processed</label
            >
          </div>
        </div>
      </div>

      <div class="row" style="margin-top: 32px">
        <div class="col-2">
          <div class="form-check">
            <label class="form-check-label">Top Scorers</label>
            <input
              class="form-control"
              *ngFor="let tid of game.topScorerIds ?? []"
              [ngModel]="tid"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card mt-3">
    <h5 class="card-header mt-0" (click)="showStatus = !showStatus">Status</h5>
    <div class="card-body" [style.display]="showStatus ? 'block' : 'none'">
      <h3>Score</h3>
      <div class="row mt-3">
        <div class="col-1">
          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-input"
              id="overtime"
              name="overtime"
              [(ngModel)]="game.overtime"
            />
            <label class="form-check-label" for="overtime">Overtime</label>
          </div>
        </div>
        <div class="col-1">
          <div class="form-check">
            <input
              type="checkbox"
              class="form-check-input"
              id="shootout"
              name="shootout"
              [(ngModel)]="game.shootout"
            />
            <label class="form-check-label" for="shootout">Shootout</label>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-1">
          <label>Home Score</label>
          <input
            min="0"
            type="number"
            name="home_score"
            class="form-control"
            [(ngModel)]="game.homeGoals"
          />
        </div>
        <div class="col-1">
          <label>Away Score</label>
          <input
            min="0"
            type="number"
            name="away_score"
            class="form-control"
            [(ngModel)]="game.awayGoals"
          />
        </div>
        <div class="col-2 d-flex align-items-end">
          <button
            mat-raised-button
            type="button"
            color="accent"
            (click)="recomputeScore()"
            [disabled]="!game._id"
            title="Recompute home/away score from goal events"
          >
            Recompute Score
          </button>
        </div>
      </div>
      <h3>Points</h3>
      <div class="row mt-3">
        <div class="col-1">
          <label>Home Points</label>
          <input
            min="0"
            type="number"
            name="home_points"
            class="form-control"
            [(ngModel)]="game.homePoints"
          />
        </div>
        <div class="col-1">
          <label>Away Points</label>
          <input
            min="0"
            type="number"
            name="away_points"
            class="form-control"
            [(ngModel)]="game.awayPoints"
          />
        </div>
        <div
          class="col-2 d-flex align-items-end"
          *ngIf="game.pointSystemAvailable"
        >
          <button
            mat-raised-button
            type="button"
            color="accent"
            (click)="recalculatePoints()"
            [disabled]="isRecalculatePointsDisabled"
            [title]="recalculatePointsTooltip"
          >
            Recalculate Points
          </button>
        </div>
      </div>
      <h3>Status</h3>
      <div class="row mt-3">
        <div class="col-2" *ngIf="game.gameId">
          <label>SIHF Status</label>
          <select
            [(ngModel)]="game.sihfStatus"
            name="status"
            class="form-control"
          >
            <option *ngFor="let key of sihfGameStatusKeys" [ngValue]="key">{{
              sihfGameStatus[key]
            }}</option>
          </select>
        </div>
        <div class="col-2">
          <label>Game Progress</label>
          <select
            [(ngModel)]="game.progress"
            name="stateStatus"
            class="form-control"
          >
            <option [ngValue]="null"></option>
            <option
              *ngFor="let progressKey of gameProgressOptions"
              [ngValue]="progressKey"
              >{{ progressKey }}</option
            >
          </select>
        </div>
        <div class="col-2">
          <label>Collection Status</label>
          <select
            [(ngModel)]="game.status"
            (ngModelChange)="onGameStatusChange($event)"
            name="status"
            class="form-control"
          >
            <option *ngFor="let status of gameStatusOptions" [value]="status">{{
              status
            }}</option>
          </select>
        </div>
        <div class="col-2">
          <label>Aggregation Status</label>
          <select
            [(ngModel)]="game.aggregationStatus"
            name="aggregationStatus"
            class="form-control"
          >
            <option></option>
            <option
              *ngFor="let status of aggregationStatusOptions"
              [value]="status"
              >{{ status }}</option
            >
          </select>
        </div>
        <div class="col-2">
          <label>Live Stream Archiving Status</label>
          <select
            [ngModel]="game.finalization?.status"
            (change)="updateFinalizationStatus($event.target.value)"
            name="finalizationStatus"
            class="form-control"
          >
            <option></option>
            <option
              *ngFor="let status of finalizationStatusOptions"
              [value]="status"
              >{{ status }}</option
            >
          </select>
        </div>
        <div *ngIf="game.goalClips" class="col-2">
          <label>Goal Clips Status</label>
          <select
            [(ngModel)]="game.goalClipsStatus"
            name="goalClipsStatus"
            class="form-control"
          >
            <option></option>
            <option
              *ngFor="let status of videoClipsStatusOptions"
              [value]="status"
              >{{ status }}</option
            >
          </select>
        </div>
        <div *ngIf="game.isExportVideoReviewClips" class="col-2">
          <label>Video Review Clips</label>
          <select
            [(ngModel)]="game.exportVideoReviewClipsStatus"
            name="exportVideoReviewClipsStatus"
            class="form-control"
          >
            <option></option>
            <option
              *ngFor="let status of videoClipsStatusOptions"
              [value]="status"
              >{{ status }}</option
            >
          </select>
        </div>
      </div>
    </div>
  </div>

  <!-- Keep the roster component mounted when marking a game as training so the
       loaded roster remains available for confirmation before the first save request. -->
  <div
    *ngIf="(authService.hasPermission('read:dc-roster') | async) === true"
    [style.display]="game.isTrainingGame ? 'none' : null"
    class="card mt-3"
  >
    <h5
      class="card-header mt-0"
      (click)="showDataCollectorRoster = !showDataCollectorRoster"
    >
      DC Roster
    </h5>
    <div class="card-body" [style.display]="showDataCollectorRoster ? 'block' : 'none'">
      <app-dc-roster [gameId]="game?._id"></app-dc-roster>
    </div>
  </div>

  <button mat-button class="apply-button" (click)="apply()"> Apply </button>

  <button
    mat-raised-button
    color="primary"
    class="save-button ml-3"
    (click)="save()"
  >
    Save and Close
  </button>
</div>
